// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-user {
  background: none;
  border: none;
  float: right;
  font-size: 14px;
  width: 33%;
  color: rgb(85, 83, 83);
  margin-bottom: 2%;
}
.add-user:hover {
  background-color: #a25035;
  color: #fff;
  float: right;
}

.icon-style {
  float: right;
  font-size: 16px;
  margin: 5px;
  margin-top: 0px;
  margin-bottom: 10px;
  color: black;
  cursor: pointer;
}
.resourcenav-outerdiv {
  display: inline-block;
  width: 100%;
  height: 95vh;
  background-color: #f5f5f5;
  border-radius: 20px 0px 0px 20px;
  overflow-y: auto;
}
.adduser-icon {
  font-size: 25px;
  /* margin-bottom: 1px */;
  margin: 2%;
  margin-left: 2%;
  cursor: pointer;
}
.file-downloadicon{
  font-size: 28px;
  display: inline;
  color: rgb(85, 83, 83);
  padding-bottom:1%;
  margin-left: 1%;
}
.resourcenav-search {
  margin-left: 3%;
  margin-bottom: 2%;
  width: 90%;
  display: inline-block;
}
.resourcenav-innerdiv {
  width: 98%;
  height: calc(100vh - 35vh);
  overflow-y: auto;
  border-radius: 20px 0px 0px 20px;
}
/* @media screen and (min-width : 600px)  {
  .resourcenav-innerdiv {
    width: 98%;
    height: calc(100vh - 230px);
    max-height: 55vh;
    overflow-y: auto;
    border-radius: 20px 0px 0px 20px;
  } 
} */

.dropdown-style {
  width:30%;
  margin:1%;
  margin-right:2.5%;
  float: right;
}

.icons-div-usermanage {
  /* margin-right: 5%; */
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (min-width : 600px) and (max-width : 1200px){
  .adduser-icon {
    font-size: 25px;
    margin:2px;
    margin-left: 2%;
    cursor: pointer;
  }
  /* .icons-div-usermanage {
    margin-left: 1%;
  } */
  .dropdown-style {
    width: 30%;
  }
  .add-user {
    background: none;
    border: none;
    float: right;
    font-size: 10px;
    width: 20%;
    color: rgb(85, 83, 83);
    margin-bottom: 2%;
  }
}
.usercard-innerdiv{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    border-radius: 10px 10px 10px 10px ;
    box-shadow:
      0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding:  1%;
}
.fauser-icon{
    margin: 10%;
    display: block;
    width: 65%;
    height: 65%;
    border-radius: 5%;
}
.resourcenav-leftdiv{
    display: inline-block;
    width: 30%;
    height: 100%;
}
.resourcenav-rightdiv{
    display: inline-block;
    width: 70%;
    height: 100%;
    /* margin: 2%; */
}
.resourcenav-items{
    font-Size: 13px;
    font-weight: 500;
    margin-top: 3%;
    color: grey;
}


`, "",{"version":3,"sources":["webpack://./src/components/modules/userManagement/resourceManagement/ResourceManagementNav.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;AAClC;AACA;;;;;;;;GAQG;;AAEH;EACE,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;IACf,UAAU;IACV,eAAe;IACf,eAAe;EACjB;EACA;;KAEG;EACH;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,UAAU;IACV,sBAAsB;IACtB,iBAAiB;EACnB;AACF;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC;sEACkE;IAClE,YAAY;AAChB;AACA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf","sourcesContent":[".add-user {\n  background: none;\n  border: none;\n  float: right;\n  font-size: 14px;\n  width: 33%;\n  color: rgb(85, 83, 83);\n  margin-bottom: 2%;\n}\n.add-user:hover {\n  background-color: #a25035;\n  color: #fff;\n  float: right;\n}\n\n.icon-style {\n  float: right;\n  font-size: 16px;\n  margin: 5px;\n  margin-top: 0px;\n  margin-bottom: 10px;\n  color: black;\n  cursor: pointer;\n}\n.resourcenav-outerdiv {\n  display: inline-block;\n  width: 100%;\n  height: 95vh;\n  background-color: #f5f5f5;\n  border-radius: 20px 0px 0px 20px;\n  overflow-y: auto;\n}\n.adduser-icon {\n  font-size: 25px;\n  /* margin-bottom: 1px */;\n  margin: 2%;\n  margin-left: 2%;\n  cursor: pointer;\n}\n.file-downloadicon{\n  font-size: 28px;\n  display: inline;\n  color: rgb(85, 83, 83);\n  padding-bottom:1%;\n  margin-left: 1%;\n}\n.resourcenav-search {\n  margin-left: 3%;\n  margin-bottom: 2%;\n  width: 90%;\n  display: inline-block;\n}\n.resourcenav-innerdiv {\n  width: 98%;\n  height: calc(100vh - 35vh);\n  overflow-y: auto;\n  border-radius: 20px 0px 0px 20px;\n}\n/* @media screen and (min-width : 600px)  {\n  .resourcenav-innerdiv {\n    width: 98%;\n    height: calc(100vh - 230px);\n    max-height: 55vh;\n    overflow-y: auto;\n    border-radius: 20px 0px 0px 20px;\n  } \n} */\n\n.dropdown-style {\n  width:30%;\n  margin:1%;\n  margin-right:2.5%;\n  float: right;\n}\n\n.icons-div-usermanage {\n  /* margin-right: 5%; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media screen and (min-width : 600px) and (max-width : 1200px){\n  .adduser-icon {\n    font-size: 25px;\n    margin:2px;\n    margin-left: 2%;\n    cursor: pointer;\n  }\n  /* .icons-div-usermanage {\n    margin-left: 1%;\n  } */\n  .dropdown-style {\n    width: 30%;\n  }\n  .add-user {\n    background: none;\n    border: none;\n    float: right;\n    font-size: 10px;\n    width: 20%;\n    color: rgb(85, 83, 83);\n    margin-bottom: 2%;\n  }\n}\n.usercard-innerdiv{\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 100%;\n    border-radius: 10px 10px 10px 10px ;\n    box-shadow:\n      0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    padding:  1%;\n}\n.fauser-icon{\n    margin: 10%;\n    display: block;\n    width: 65%;\n    height: 65%;\n    border-radius: 5%;\n}\n.resourcenav-leftdiv{\n    display: inline-block;\n    width: 30%;\n    height: 100%;\n}\n.resourcenav-rightdiv{\n    display: inline-block;\n    width: 70%;\n    height: 100%;\n    /* margin: 2%; */\n}\n.resourcenav-items{\n    font-Size: 13px;\n    font-weight: 500;\n    margin-top: 3%;\n    color: grey;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
